import FF from "@/components/forms/FormField.module.css";

import { FormFieldChildren, type FormFieldChildrenProps } from "@/components/forms/FormField.tsx";
import { standardFieldAttributes, type StandardFieldProps } from "@/components/forms/standardFieldAttributes.tsx";
import { cn } from "@/utils/classNames.ts";
import type { TextFieldProps } from "react-aria-components";
import { TextField } from "react-aria-components";

export interface WTextFieldProps
    extends
        Omit<TextFieldProps, "children" | "className">,
        StandardFieldProps,
        Pick<FormFieldChildrenProps, "wide" | "description" | "children" | "label" | "errorMessage"> {
    className?: string;
    block?: boolean;
    headless?: boolean;
}

export function WTextField({
    className,
    children,
    wide,
    block,
    headless,
    description,
    label,
    errorMessage,
    ...props
}: WTextFieldProps) {
    return (
        <TextField
            className={cn(FF.FormField, className, block && FF.Block, headless && FF.Headless)}
            {...props}
            {...standardFieldAttributes(props)}
        >
            <FormFieldChildren wide={wide} description={description} label={label} errorMessage={errorMessage}>
                {children}
            </FormFieldChildren>
        </TextField>
    );
}
